import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-明细",
  "use": "icon-明细-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-明细\"><path d=\"M128 128h320v320H128zM544 128h352v96H544zM544 352h352v96H544zM128 576h320v320H128zM544 576h352v96H544zM544 800h352v96H544z\" p-id=\"28773\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol